"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bindingIdentifierSymbol = void 0;
exports.bindingIdentifierSymbol = Symbol.for('@inversifyjs/container/bindingIdentifier');
//# sourceMappingURL=BindingIdentifier.js.map